import { Language } from '@localization-lib/language/models/Language'

const translationFiles: { [lang in Language]: string } = {
    [Language.DE]: 'de.json',
    [Language.EN]: 'en.json',
}

export const getTranslationFileFromLanguage = (lang: Language) =>
    translationFiles[lang]
